const theme = [
  {
    id: "sentinel",
    hostnames: [],
    name: "Sentinel",
    title: "Sentinel Partner Platform",
    path: "sentinel",
    dark: {
      primary: "#1169EE",
      secondary: "#0D4FB2",
      error: "#D70000",
    },
    light: {
      primary: "#1169EE",
      secondary: "#0D4FB2",
      error: "#D70000",
    },
    colorVariables: {
      primary: "#1169EE",
      secondary: "#0D4FB2",
      navigationBarBackgroundColor: "rgba(0, 0, 0, 0.1)",
      navigationBarColor: "#000000",
    },
  },
  {
    id: "beneteau",
    hostnames: ["partners.seanapps.app", "stage-partners.seanapps.app"],
    name: "Beneteau",
    title: "SEANAPPS Partner Platform",
    path: "beneteau",
    dark: {
      primary: "#00006e",
      secondary: "#0087ff",
      accent: "#7CB342",
      success: "#4CAF50",
      info: "#6156d8",
      warning: "#1565C0",
      error: "#FF7043",
    },
    light: {
      primary: "#00006e",
      secondary: "#0087ff",
      accent: "#7CB342",
      success: "#4CAF50",
      info: "#6156d8",
      warning: "#1565C0",
      error: "#FF7043",
    },
    colorVariables: {
      primary: "#00006e",
      secondary: "#0087ff",
      navigationBarBackgroundColor: "#0087ff",
      navigationBarColor: "white",
    },
  },
];

const logo = [
  {
    id: "sentinel",
    hostnames: [],
    name: "Sentinel",
    path: "sentinel",
  },
  {
    id: "beneteau",
    hostnames: ["partners.seanapps.app", "stage-partners.seanapps.app"],
    name: "Beneteau",
    path: "beneteau",
  },
];

const clientIDs = [
  {
    hostnames: [],
    name: "Sentinel",
    id: "sentinel",
    clientId: "726b8d323a4662ad4023",
    clientSecret: "8954262e0e67556b1db20a502bbdb98de01f2215",
  },
  {
    hostnames: ["partners.seanapps.app", "stage-partners.seanapps.app"],
    name: "Beneteau",
    id: "beneteau",
    clientId: "327acee46813510051d0",
    clientSecret: "52265a8f6eae098ad65f07a723d089b6cb607f3a",
  },
];

const links = [
  {
    id: "sentinel",
    hostnames: [],
    name: "Sentinel",
    privacyPolicy:
      "https://web-docs.sentinelmarine.net/en/platform.sentinelmarine.net/privacy-policy",
    termsOfUse:
      "https://web-docs.sentinelmarine.net/en/platform.sentinelmarine.net/terms-of-use",
    termsAndConditions:
      "https://web-docs.sentinelmarine.net/en/sentinel/terms-and-conditions-partner",
    legalNotice: false,
    supportEmail: "support@sentinelmarine.net",
  },
  {
    id: "beneteau",
    hostnames: ["partners.seanapps.app", "stage-partners.seanapps.app"],
    name: "Beneteau",
    privacyPolicy:
      "https://web-docs.sentinelmarine.net/en/partners.seanapps.app/privacy-policy",
    termsOfUse:
      "https://web-docs.sentinelmarine.net/en/partners.seanapps.app/terms-of-use",
    termsAndConditions:
      "https://web-docs.sentinelmarine.net/en/partners.seanapps.app/terms-and-conditions-partner",
    legalNotice: "https://www.seanapps.fr/en/legal-notice/",
    supportEmail: "contact@seanapps.fr",
  },
];

const analyticsConfig = [
  {
    id: "sentinel",
    hostnames: [],
    ga: {
      config: { id: process.env.VUE_APP_GOOGLE_ANALYTICS_SENTINEL },
      appName: "Partner Platform Sentinel",
      pageTrackerScreenviewEnabled: true,
    },
    hotjar: null,
  },

  {
    id: "beneteau",
    hostnames: ["partners.seanapps.app", "stage-partners.seanapps.app"],
    ga: {
      config: { id: process.env.VUE_APP_GOOGLE_ANALYTICS_SEANAPPS },
      appName: "Partner Platform Seanapps",
      pageTrackerScreenviewEnabled: true,
    },
    hotjar: {
      id: "3390905",
      isProduction: true,
    },
  },
];

const defaultTheme = theme.find((element) => element.id === "sentinel");
const defaultLogo = logo.find((element) => element.id === "sentinel");
const defaultClientIDs = clientIDs.find((element) => element.id === "sentinel");
const defaultLinks = links.find((element) => element.id === "sentinel");
const defaultAnalytics = analyticsConfig.find(
  (element) => element.id === "sentinel",
);

export default {
  theme,
  defaultTheme,
  logo,
  defaultLogo,
  clientIDs,
  defaultClientIDs,
  links,
  defaultLinks,
  analyticsConfig,
  defaultAnalytics,
};
